import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface CommonState {
  isLoading: boolean
  triggerTime: number
}

const initialState: CommonState = {
  isLoading: false,
  triggerTime: 0,
}

export const commonDucks = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setTriggerTime: (state, action: PayloadAction<number | undefined>) => {
      state.triggerTime = action.payload ?? Date.now()
    },
  },
})

export const { setLoading, setTriggerTime } = commonDucks.actions
export default commonDucks.reducer
